import * as Api from '@Api/index';
import { BackendError } from '@Common/errors';

import type { LanguageCode } from '@Types/Base';
import type { DaDataHint } from '@Types/DaData';

export interface Params {
  chunk: string;
  country: string;
  currentLang: LanguageCode;
  count?: number;
}

export interface Response {
  result: 'success' | 'error';
  data: DaDataHint[];
}

/**
 * Возвращает подсказки для ввода адреса
 */
async function getDaDataHints(params: Params, opts?: RequestInit) {
  const { chunk, country, currentLang, count = 5 } = params;
  const url = '/backend/pec/address-helper';
  const language = `${currentLang.toLowerCase()}_${currentLang}`;
  const res = await Api.queryProxi<Response>(url, {
    ...(opts || {}),
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      query: `{
          addresses(chunk: "${chunk}", count: ${count}, country: "${country}", language: "${language}") {
            fullAddress
            country
            city
            cityFormatted
            street
            house
            latitude
            longitude
          }
        }`,
      variables: null,
      operationName: null,
    }),
  });

  if (res.result !== 'success') throw new BackendError(url, res);

  return res.data;
}

export default getDaDataHints;
